import React from 'react'

const Nodejs_Coding_Assignmet_1 = () => {
  return (
    <div>
      <h1>Assignment 1</h1>
    </div>
  )
}

export default Nodejs_Coding_Assignmet_1
